// extracted by mini-css-extract-plugin
export default {"colorCrash":"#ff5461","colorAnr":"#a452dd","colorError":"#fb835e","colorOom":"#6669fe","colorJank":"#e19a00","colorHang":"#e12000"};